import { FaCheckCircle } from 'react-icons/fa';
import styles from './EmailVerified.module.css';
import Button from '../../components/Button/Button';
import buttonStyles from '../../components/Button/Button.module.css';
import { useNavigate } from 'react-router-dom';

const EmailVerified = () => {
    const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <FaCheckCircle size={80} className={styles.icon} />
      <h1 className={styles.title}>Email Verified!</h1>
      <p className={styles.message}>You can now log in to your account.</p>
      <Button className={buttonStyles.inverted1} onClick={() => navigate('/login')}>Go to Login</Button>
    </div>
  );
};

export default EmailVerified;
